import { Component } from 'react'
import { connect } from 'react-redux'
import RecentTopics from 'components/RecentTopics'
import { NavigationHOC } from 'hocs'
import { selectRecentTopics } from './selectors'
import { filterByCustomer, getCustomer } from '../../helpers/utils'

class RecentTopicsContainer extends Component {
  generateProps = () => ({
    ...this.props,
    topics: filterByCustomer(this.props.topics, getCustomer())
  })

  render() {
    return <RecentTopics {...this.generateProps()} />
  }
}

const mapStateToProps = (state) => ({ topics: selectRecentTopics(state) })

export default connect(mapStateToProps)(NavigationHOC(RecentTopicsContainer))
